import type { RootState } from "@src/store/rootState";
import { selectedExperience } from "@src/store/slices/experiences";
import { Experience } from "@src/store/slices/experiences/types";

export const isShippingTest = (state: RootState) => {
  const experience = selectedExperience(state);
  if (!experience) return false;

  return isExperienceShippingTest(experience)(state);
};

export const isExperienceShippingTest =
  (experience: Experience) => (_state: RootState) => {
    return experience?.testTypes.hasTestShipping ?? false;
  };
